module.exports = __webpack_public_path__ + "assets/img/DS.8d58f98e.jpg";